import SearchInput from './js/SearchInput';

export default SearchInput;
